<template>
	<article>
		<section
			id="video-container"
			class="container-expanded container band"
		>
			<h1>{{ title }}</h1>
			<h2 v-if="subTitle">{{ subTitle }}</h2>

			<LoadingComponent
				v-if="loading"
				:loading="true"
			/>
			<template v-else>
				<YoutubeComponent
					:id="youtubeIdFromUrl(message.youtubeSrc)"
					v-if="message?.youtubeSrc"
				/>
				<div v-else>
					<p>Sorry we couldn't find your message.</p>
					<p>
						<router-link
							:to="{
								name: routerNameRedirect,
							}"
						>
							Click here
						</router-link>
						to go to the most recent one.
					</p>
				</div>
			</template>
		</section>

		<section
			v-if="message?.content"
			class="content band"
		>
			<div v-html="message.content" />
		</section>
	</article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { request } from '@/services/requestService';
import LoadingComponent from '@/components/shared/LoadingComponent.vue';
import type { Message } from '@/interfaces/messageInterface';
import { capitalise, youtubeIdFromUrl } from '@/helpers';
import YoutubeComponent from '@/components/shared/YoutubeComponent.vue';

export default defineComponent({
	components: { LoadingComponent, YoutubeComponent },
	props: {
		type: {
			type: String,
			default: 'principal',
		},
	},
	data() {
		return {
			loading: true,
			message: null as null | Message,
		};
	},
	computed: {
		title() {
			const type = capitalise(this.type);
			const date =
				this.message?.date ??
				new Date().toLocaleDateString('en-AU', {
					month: 'long',
					year: 'numeric',
				});
			return `Partner ${type} Message - ${date}`;
		},
		subTitle() {
			return this.message?.title ?? '';
		},
		routerNameRedirect() {
			return `${this.type}Message`;
		},
	},
	watch: {
		$route() {
			this.init();
		},
	},
	beforeMount() {
		this.init();
	},
	methods: {
		youtubeIdFromUrl,
		async init() {
			this.message = null;
			this.loading = true;

			const res = await request<{ message: Message; messages: Message[] }>('publicMessage', 'getAll', {
				type: this.type,
				slug: this.$route.params.slug,
			});

			this.loading = false;

			if (!res.success) {
				return;
			}

			this.message = res.data.message;
		},
	},
});
</script>

<style scoped lang="scss">
article {
	#video-container {
		background-color: black;
		color: rgb(255 255 255 / 90%);

		h1 {
			margin: 0;
			font-size: 3.6rem;
		}

		h2 {
			margin: 10px 0 40px 0;
			font-size: 2.4rem;
		}
	}
}
</style>
